import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyDzNLAXMYuotA6VJDhv3pzasnxX7DtKgA0",
  authDomain: "lavernai.firebaseapp.com",
  projectId: "lavernai",
  storageBucket: "lavernai.firebasestorage.app",
  messagingSenderId: "435662092000",
  appId: "1:435662092000:web:3772fc962d8d15b7428285",
  measurementId: "G-Y8VLCVRBVP"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app); 